import React, { useEffect, useState } from "react";

import { fetchVehiclesUptime, fetchVehicleTags } from "src/services/routes";
import { SidebarVehicles, VehicleDetails } from "@components";
import { handleSaveLogError } from "@utils";
import { getVehiclesPositions } from "src/services/fleets";
import { FleetLocationVehicle, IPositionVehicle, IVehicle } from "@types";
import { useAppSelector } from "@store";
import { ISandboxMarker } from "src/components/Map";
import { MapDrawingProvider } from "../../providers/MapDrawingContext";
import { ApplicationLayout, Sidebar } from "@rio-cloud/rio-uikit";
import { Groups } from "src/components/SidebarVehicles";
import { useHandleRoutes } from "@hooks";
import MapCluster from "./map";

const locationDefault = { lat: -23.5475, lng: -46.63611 }
const mapZoomDefault = 5;

const CurrencyVehicleLocationScreen = () => {
    const [groupsSelected, setGroupsSelected] = useState<string[]>([]);
    const [itemsSelected, setItemsSelected] = useState<string[]>([]);

    const { openVehicles } = useAppSelector(state => state.fleet);
    const [groups, setGroups] = useState<Groups[]>([])
    const [allPostitions, setAllPositions] = useState<IPositionVehicle[]>();
    const [mapCenter, setMapCenter] = useState<{ lat: number, lng: number }>(locationDefault);
    const [mapZoom, setMapZoom] = useState<number>(mapZoomDefault);
    const [allVehicles, setAllVehicles] = useState<IVehicle[]>([]);
    const [openDetail, setOpenDetail] = useState(false);
    const { handleIconName } = useHandleRoutes();

    const [markers, setMarkers] = useState<ISandboxMarker[]>([]);
    const [copyMarkes, setCopyMarkes] = useState<ISandboxMarker[]>([]);
    const [vehicle, setVehicle] = useState<IVehicle>();
    const [position, setPosition] = useState<IPositionVehicle>();

    const getAll = async () => {
        const vehciles = await fetchVehiclesUptime();
        const restags = await fetchVehicleTags(1, 100);
        const tags = restags?.data?.result?.result?.map((res: { tagId: string, tagName: string }) => {
            return {
                id: res.tagId,
                name: res.tagName,
            }
        })
        setGroups(tags);
        setAllVehicles(vehciles);
    }

    useEffect(() => {
        getAll();
    }, [])

    const getLocation = async () => {
        try {
            const response = await getVehiclesPositions();
            const resMarkers = response.data?.result?.map((res: FleetLocationVehicle) => {
                const vehicle = allVehicles?.find((v) => v.id === res.id);
                return {
                    id: res.id,
                    markerProps: {
                        iconNames: [handleIconName(vehicle?.type)],
                        name: vehicle?.name,
                        markerColor: "bg-map-marker-asset",
                        active: false,
                        fixed: false,
                    },
                    position: {
                        lat: res.latitude,
                        lng: res.longitude,
                    },
                    isInfoMarker: true,
                    type: vehicle?.type,
                };
            })

            setMarkers(resMarkers);
            setCopyMarkes(resMarkers);
            setAllPositions(response.data?.result);
        } catch (error) {
            handleSaveLogError('handleFilter', error)
        }
    }

    const handleClear = () => {
        setMarkers(copyMarkes)
        setMapZoom(mapZoomDefault);
        setMapCenter(locationDefault);
        setOpenDetail(false);
        setPosition(undefined);
        setGroupsSelected([]);
        setItemsSelected([]);
    }

    const handleSelect = (groups: string[], items: string[]) => {
        setOpenDetail(true);
        setGroupsSelected(groups);
        setItemsSelected(items);

        if (items?.length > 0) {
            const m = copyMarkes?.find((res) => res.id === items?.[0]);
            const v = allVehicles.find((res) => res.id === items?.[0]);
            const p = allPostitions?.find((res) => res.id === items?.[0]);

            if (m) {
                setMarkers([m]);
                setMapCenter({
                    lat: m.position.lat,
                    lng: m.position.lng,
                });
                setMapZoom(20);
            }

            if (v) {
                setVehicle(v);
            }

            if (p) {
                setPosition(p)
            } else {
                setPosition(undefined);
            }
        } else {
            handleClear()
        }

    }

    useEffect(() => {
        if (allVehicles && groups) {
            getLocation();
        }
    }, [allVehicles, groups])

    return (
        <>
            <ApplicationLayout.Sidebar className="left z-index-2 height-100pct">
                <Sidebar
                    width={300}
                    closed={!openVehicles}
                    onClose={undefined}
                    disableClose
                    headerClassName="display-none"
                >
                    <SidebarVehicles
                        allVehicles={allVehicles}
                        groups={groups}
                        handleSelected={handleSelect}
                        groupsSelected={groupsSelected}
                        itemsSelected={itemsSelected}
                    />
                </Sidebar>
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Sidebar className="right z-index-2 height-100pct">
                <Sidebar
                    closed={!openDetail}
                    width={380}
                    onClose={() => {
                        setOpenDetail(false);
                        handleClear();
                    }}
                    showHeaderBorder={false}
                    title='Veículo'
                    className="padding-25"
                    headerClassName="padding-x-1"
                >
                    <VehicleDetails
                        vehicle={vehicle}
                        position={position}
                    />
                </Sidebar>
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Body innerClassName="padding-0" className="height-100pct">

                <React.Fragment>
                    <MapDrawingProvider>
                        <MapCluster
                            showInterestPoints
                            position={mapCenter}
                            zoom={mapZoom}
                            markers={markers}
                            handleSelect={(id) => {
                                handleSelect([], [id]);
                            }}
                        />
                    </MapDrawingProvider>
                </React.Fragment>

            </ApplicationLayout.Body>

        </>
    )
}

export default CurrencyVehicleLocationScreen;